'use strict';
import {reduxList as assetProjectList} from '../redux/assetProjectList';
import {createProjectRequest} from '../redux/createProject';
import {deleteAssetProjectRequest} from '../redux/deleteAssetProject';
import {deleteProjectRequest} from '../redux/deleteProject';
import {updateProjectRequestModal} from '../redux/updateProject';


export const epics = [
  ...assetProjectList.epics.epics,
  ...createProjectRequest.epics.epics,
  ...deleteAssetProjectRequest.epics.epics,
  ...deleteProjectRequest.epics.epics,
  ...updateProjectRequestModal.epics.epics,
];



// WEBPACK FOOTER //
// ./src/js/projects/epics/index.js